<template>
  <tabs
    :tab-name="['Detail', 'Notes']"
    :tab-icon="['event_available', 'text_snippet']"
    class="page-subcategories"
    nav-pills-icons
    color-button="primary"
  >
    <template slot="tab-pane-1">
      <supplier-edit :supplier="supplier" @supplierUpdated="supplierUpdated" />
    </template>

    <template slot="tab-pane-2">
      <supplier-tabs-notes :supplier="supplier" />
    </template>
  </tabs>
</template>

<script>
import { Tabs } from "@/components";

import SupplierEdit from "./SupplierEdit";
import SupplierTabsNotes from "./SupplierTabsNotes";

export default {
  props: ["supplier"],

  components: {
    Tabs,
    SupplierEdit,
    SupplierTabsNotes
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    supplierUpdated(updateInfo) {
      this.$emit("supplierUpdated", updateInfo);
    }
  }
};
</script>
